module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加渠道"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "createChannelForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.channelRules,
      "model": _vm.createChannelParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道名称：",
      "prop": "channelName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入渠道名称"
    },
    model: {
      value: (_vm.createChannelParams.channelName),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "channelName", $$v)
      },
      expression: "createChannelParams.channelName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "获客终端：",
      "prop": "channelType"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.createChannelParams.channelType),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "channelType", $$v)
      },
      expression: "createChannelParams.channelType"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "MOBILE"
    }
  }, [_vm._v("手机端")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "PC"
    }
  }, [_vm._v("PC端")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道分类：",
      "prop": "type"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.createChannelParams.type),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "type", $$v)
      },
      expression: "createChannelParams.type"
    }
  }, _vm._l((_vm.$constant.channelTypeEnum), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道参数：",
      "prop": "channelParam"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入渠道参数"
    },
    model: {
      value: (_vm.createChannelParams.channelParam),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "channelParam", $$v)
      },
      expression: "createChannelParams.channelParam"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.createChannelParams.status),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "status", $$v)
      },
      expression: "createChannelParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "来源：",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.createChannelParams.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "tchChannel", $$v)
      },
      expression: "createChannelParams.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "渠道描述："
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      },
      "placeholder": "请输入渠道描述"
    },
    model: {
      value: (_vm.createChannelParams.description),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "description", $$v)
      },
      expression: "createChannelParams.description"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": 90,
      "label": "市场专员"
    }
  }, [_c('AdminUserMultSelect', {
    attrs: {
      "status": 1,
      "adminGroupCode": "marketGroup"
    },
    model: {
      value: (_vm.createChannelParams.adminUserIds),
      callback: function($$v) {
        _vm.$set(_vm.createChannelParams, "adminUserIds", $$v)
      },
      expression: "createChannelParams.adminUserIds"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAddActivity
    },
    on: {
      "click": _vm.createNewChannel
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47d531b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/modal/CreateChannelModal.vue
// module id = 1779
// module chunks = 8